// src/components/22.js
import React from 'react';

const Componente22 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 22</h2>
      <p>
        Para una persona nacida el día 22, el número de propósito asociado sería 22.
      </p>
      <p>
        En numerología, el número 22 es conocido como el "Maestro Constructor". Este número está relacionado con la realización de grandes objetivos y la creación de un impacto significativo en el mundo. Las personas nacidas en este día suelen tener una visión amplia y el deseo de llevar a cabo proyectos ambiciosos. Su propósito puede incluir:
      </p>
      <ul>
        <li><strong>Construir y Realizar:</strong> Estas personas están destinadas a hacer realidad sus sueños y visiones, convirtiéndose en constructores de un futuro mejor.</li>
        <li><strong>Guiar a Otros:</strong> Su propósito puede incluir guiar y apoyar a otros en su camino hacia el éxito y la realización de sus objetivos.</li>
        <li><strong>Inspirar Cambio:</strong> Tienen el potencial de inspirar a otros a tomar acción y hacer cambios significativos en sus vidas y en la sociedad.</li>
        <li><strong>Fomentar la Colaboración:</strong> Su enfoque en la creación de un impacto duradero a menudo implica trabajar en colaboración con otros.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 22</h3>
      <ul>
        <li><strong>Visionarios:</strong> Tienen una visión clara de lo que quieren lograr y cómo hacerlo.</li>
        <li><strong>Prácticos:</strong> Su enfoque práctico les permite llevar a cabo grandes proyectos de manera efectiva.</li>
        <li><strong>Líderes Naturales:</strong> Poseen habilidades de liderazgo que les permiten guiar y motivar a otros.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 22 son maestros constructores con un propósito de realizar grandes objetivos y crear un impacto positivo en el mundo. Su visión amplia, habilidades prácticas y capacidad para guiar a otros los convierten en líderes influyentes en su camino hacia el éxito.
      </p>
    </div>
  );
};

export default Componente22;
